import { useEffect, useState } from 'react';

// Bottom padding for a page with a floating action bar (Add to Cart, Book
// Now, Checkout…): the bar's measured height plus `offset` (the gap between
// the bar and the screen edge, incl. the iPhone home bar) and a small gap, so
// the last content ends just above the bar instead of hiding behind it or
// leaving a large empty band. `offset` is a CSS length.
//
// Returns [barRef, padding]: put `ref={barRef}` on the fixed bar (a callback
// ref, so a bar that only renders after loading is still measured).
export default function useFloatingBarPadding(visible, offset = '0px') {
  const [bar, setBar] = useState(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!bar) return undefined;
    // Measure now, then keep up with changes (wrapping text, rotation).
    setHeight(bar.offsetHeight);
    const ro = new ResizeObserver(() => setHeight(bar.offsetHeight));
    ro.observe(bar);
    return () => ro.disconnect();
  }, [bar]);

  const padding = visible && height
    ? `calc(${height}px + ${offset} + 1rem)`
    : 'calc(2rem + var(--sai-bottom))';
  return [setBar, padding];
}
